import wire from "./wire";

function Authorized({ children, canView }) {
  if (canView) {
    return children;
  }

  return false;
}

export default function authorized(...allowedRoles) {
  return wire(allowedRoles, "canView", Authorized);
}



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/authorization/authorized.js